import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AgneseChatPage from "@/pages/AgneseChatPage";
import AdminPage from "@/pages/AdminPage";
import DirectMemberPage from "@/pages/DirectMemberPage";
import CsenFillPage from "@/pages/CsenFillPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AgneseChatPage />} />
          <Route path="/member" element={<DirectMemberPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/csen-fill" element={<CsenFillPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
